// JsFromRoutes CacheKey 79b31fa59c10a0385f2e638272ace76c
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  show: /* #__PURE__ */ definePathHelper('get', '/contact_url'),
}
